import React, { createContext, useState, useEffect } from "react";
import mainDI from "@di";
const initConfig = {
    allowTrading: false,
    liveNewsShare: false,
    passwordProtectedDownloadReports: false,
    isTaxHarvesting: false,
    showClearTax: false,
};
const WebConfigContext = createContext(initConfig);
const WebConfig = ({ children }) => {
    const [configuration, setConfiguration] = useState(null);
    const readConfig = () => {
        mainDI.common
            .readConfig()
            .then((configuration) => {
            setConfiguration(configuration);
        })
            .catch((err) => {
            setConfiguration(initConfig);
        });
    };
    useEffect(() => {
        readConfig();
    }, []);
    return (React.createElement(WebConfigContext.Provider, { value: configuration }, children));
};
export { WebConfigContext, WebConfig };
